import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getSelected = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );

  return await httpClient.get(
    exportCSV
      ? '/announcement_selection/selected/export'
      : '/announcement_selection/selected/',
    params,
  );
};

const announcementInfo = async (rol_id) => {
  return await httpClient.get(`/announcement_selection/${rol_id}/info/`);
};

const post = async (data) => {
  return await httpClient.post(`/announcement_selection/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/announcement_selection/`);
};

const get = async (id) => {
  return await httpClient.get(`/announcement_selection/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/announcement_selection/${id}/`, data);
};

const patch = async (id, data) => {
  return await httpClient.patch(`/announcement_selection/${id}/`, data);
};

const putDocument = async (data) => {
  return await httpClient.put(`/announcement_selection/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const remove = async (id) => {
  return await httpClient.delete(`/announcement_selection/${id}`);
};

const filter = async (query) => {
  return await httpClient.get(`/announcement_selection/${query}`);
};

const counters = async (id) => {
  return await httpClient.get(`/announcement_selection/${id}/counters/`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/announcement_selection/export` +
        `${query}&sort=${sortBy}` +
        `${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/announcement_selection` +
        `${query}&page[number]=${page}&page[size]=${pageSize}` +
        `&sort=${sortBy}` +
        `${searchBy}`,
    );
};

export {
  getSelected,
  announcementInfo,
  post,
  getAll,
  get,
  put,
  patch,
  putDocument,
  remove,
  filter,
  counters,
  ajaxTable,
};
